import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import heroimage from '../components/assets/global_phoenix-hero.png';

const Home = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white pt-16">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-blue-600 py-6 via-teal-600 to-cyan-600 text-white overflow-hidden ">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:py-14">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                <span className="text-white">Global Phoenix</span>
                <br />
                <span className="bg-gradient-to-r from-green-400 to-teal-500 bg-clip-text text-transparent">Pharmaceutical distributors</span> <span className="bg-gradient-to-r from-green-400 to-teal-500 bg-clip-text text-transparent"></span> and exporters
              </h1>
              <p className="text-xl mb-8 text-blue-100 max-w-2xl">
                {/* Your trusted wholesale medicine dealer serving 1000+ pharmacies across India with 300K+ medicines, competitive pricing and reliable supply chain management. */}
                Your trusted pharmaceutical partner, offering a wide range of medicines, competitive pricing and supply chain management.
              </p>

              {/* <div className="mb-8 space-y-3">
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-blue-100">Wholesale Pricing — Up to 15% Better Margins</span>
                </div>
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-blue-100">Bulk Orders — Minimum Order Quantity Benefits</span>
                </div>
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-blue-100">Credit Terms — Flexible Payment Options</span>
                </div>
              </div> */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a
                  href="https://wa.me/919048762636?text=Hello%2C%20I%20would%20like%20to%20place%20an%20order"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  <span className="flex items-center justify-center space-x-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Place Order</span>
                  </span>
                </a>
                {/* <button className="group border-2 border-white/30 text-white px-8 py-4 rounded-xl font-semibold hover:bg-white/10 backdrop-blur-sm transition-all duration-300">
                  <span className="flex items-center justify-center space-x-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    <span>Become Customer</span>
                  </span>
                </button> */}
              </div>
            </div>
            <div className="relative">
              {/* Medical Professional Image - Full */}
              <div className="relative w-full h-full min-h-[300px] rounded-3xl overflow-hidden ">
                <img
                  src={heroimage}
                  alt="Professional Medical Doctor"
                  className="w-full min-h-[300px]  rounded-3xl"
                  onError={(e) => {
                    // Fallback to a professional medical illustration if image fails to load
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'flex';
                  }}
                />

                {/* Fallback Professional Medical Illustration */}
                <div className="hidden w-full h-full items-center justify-center bg-gradient-to-br from-blue-100 to-teal-100 rounded-3xl">
                  <div className="text-center">
                    <div className="w-64 h-64 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-lg">
                      <svg className="w-32 h-32 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM12 8C13.1 8 14 8.9 14 10V11H16C16.6 11 17 11.4 17 12S16.6 13 16 13H14V15C14 16.1 13.1 17 12 17S10 16.1 10 15V13H8C7.4 13 7 12.6 7 12S7.4 11 8 11H10V10C10 8.9 10.9 8 12 8Z" />
                      </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-2">Professional Healthcare</h3>
                    <p className="text-gray-600">Trusted Medical Services</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* Statistics Section - Modern UI */}
      <div className="py-20 bg-gray-50 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-cyan-500 to-teal-500"></div>
        {/* Background Decorative Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-br from-blue-100/30 to-teal-100/30 rounded-full blur-2xl"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-gradient-to-br from-green-100/30 to-blue-100/30 rounded-full blur-2xl"></div>
          <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-gradient-to-br from-teal-100/20 to-green-100/20 rounded-full blur-xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-20">
            <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Ecosystem For All by
              <span className="block bg-gradient-to-r from-green-500 via-teal-500 to-blue-500 bg-clip-text text-transparent mt-2">
                Global Phoenix
              </span>
            </h2>
            <div className="flex items-center justify-center mb-8">
              <div className="h-px bg-gradient-to-r from-transparent via-green-300 to-transparent w-32"></div>
              <div className="mx-4 w-3 h-3 bg-gradient-to-r from-green-400 to-teal-400 rounded-full"></div>
              <div className="h-px bg-gradient-to-r from-transparent via-green-300 to-transparent w-32"></div>
            </div>
            {/* <p className="text-2xl font-semibold text-gray-800 mb-4">Order in 500+ Cities in India</p> */}
            <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
              India's Most Trusted Medicine Wholesale Dealer serving Pharmacies, Hospitals, Clinics and Medical Stores with authentic medicines and competitive wholesale pricing.
            </p>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center bg-white p-10 rounded-2xl border border-gray-100">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-teal-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">300K+</div>
              <div className="text-gray-600 font-medium text-sm">MEDICINE PRODUCTS</div>
            </div>

            <div className="text-center bg-white p-10 rounded-2xl border border-gray-100">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-100 to-green-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">25K+</div>
              <div className="text-gray-600 font-medium text-sm">WHOLESALE PARTNERS</div>
            </div>

            <div className="text-center bg-white p-10 rounded-2xl border border-gray-100">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-100 to-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                </svg>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">₹500Cr+</div>
              <div className="text-gray-600 font-medium text-sm">MONTHLY WHOLESALE VOLUME</div>
            </div>

            <div className="text-center bg-white p-10 rounded-2xl border border-gray-100">
              <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-teal-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">500+</div>
              <div className="text-gray-600 font-medium text-sm">CITIES PAN INDIA</div>
            </div>
          </div> */}

        </div>
      </div>

      {/* About Us Section */}
      <div className="py-20 bg-white relative">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                About <span className="text-green-500">Global Phoenix</span>
              </h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Welcome to Global Phoenix your premier destination for superior pharmaceutical products. As a prominent exporter in the pharmaceutical sector, we proudly serve healthcare providers and pharmacies across the globe. Our portfolio of services includes prompt and dependable delivery, competitive pricing, and tailored solutions designed to meet the distinct requirements of our clientele.
              </p>

              <div className="bg-gradient-to-r from-[#f2fcf5] to-[#f4f7fc] border border-green-100 rounded-2xl p-6 md:p-8 mb-6">
                <h3 className="text-xl md:text-2xl font-bold text-[#111827] mb-5">Our Services</h3>
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" /></svg>
                    <span className="text-sm md:text-base text-[#374151]">Prompt and dependable delivery worldwide</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" /></svg>
                    <span className="text-sm md:text-base text-[#374151]">Competitive pricing structures</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" /></svg>
                    <span className="text-sm md:text-base text-[#374151]">Tailored solutions for distinct requirements</span>
                  </li>
                </ul>
              </div>

              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                For procurement managers worldwide, reliable and timely delivery from trusted vendors is paramount. At Global Phoenix, we are resolutely committed to providing the highest standards of quality, dependability, and customer satisfaction. Our extensive product range encompasses prescription medications, generic drugs, surgical and veterinary supplies, over-the-counter products, as well as medical equipment, all sourced from reputable and certified manufacturers.
              </p>

              <div className="bg-[#f0f5ff] border-l-4 border-blue-500 rounded-r-2xl p-6 md:p-8 mb-6">
                <p className="text-sm md:text-base text-gray-700 italic font-medium leading-relaxed">
                  "We uphold the highest ethical standards in every facet of our business, striving to cultivate long-term partnerships based on trust, transparency, and mutual respect."
                </p>
              </div>

              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                Global Phoenix was founded on the fundamental belief that everyone deserves access to premium pharmaceutical products. As a leading exporter, we deliver not only exceptional products but also unparalleled service.
              </p>

            </div>

            <div className="relative">
              <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-6 text-center border border-green-100 mb-4">
                <div className="text-3xl font-bold text-green-600 mb-2">2025</div>
                <div className="text-gray-700 font-semibold text-sm">Founded</div>
              </div>
              <div className="bg-white rounded-3xl p-8 border border-gray-200">
                <h2 className="text-3xl lg:text-2xl font-bold text-gray-900 mb-6 text-center">
                  Why Choose Us
                </h2>
                <div className="grid grid-cols-2 gap-6">
                  <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-teal-50 rounded-2xl">
                    <svg className="w-12 h-12 text-blue-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <div className="text-2xl font-bold text-gray-900 mb-1">Fast</div>
                    <div className="text-sm text-gray-600">Quick Processing</div>
                  </div>
                  <div className="text-center p-6 bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl">
                    <svg className="w-12 h-12 text-green-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div className="text-2xl font-bold text-gray-900 mb-1">Reliable</div>
                    <div className="text-sm text-gray-600">Trusted Platform</div>
                  </div>
                  <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-green-50 rounded-2xl">
                    <svg className="w-12 h-12 text-teal-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                    <div className="text-2xl font-bold text-gray-900 mb-1">Secure</div>
                    <div className="text-sm text-gray-600">Data Protection</div>
                  </div>
                  <div className="text-center p-6 bg-gradient-to-br from-yellow-50 to-green-50 rounded-2xl">
                    <svg className="w-12 h-12 text-yellow-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <div className="text-2xl font-bold text-gray-900 mb-1">24/7</div>
                    <div className="text-sm text-gray-600">Support</div>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-r from-green-400 to-blue-500 rounded-2xl p-6 text-center text-white shadow-lg mt-6">
                <p className="text-3xl font-bold mb-2">Quality Guaranteed</p>
                <p className="text-sm md:text-base opacity-90">Certified manufacturers & ethical standards</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Our Commitment to Clients */}
      <div className="bg-[#f9fafb] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">Our Commitment to Clients</h2>
            <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto">
              We are resolutely committed to providing the highest standards of quality, dependability, and customer satisfaction.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 md:p-10 border border-gray-100 shadow-sm">
              <svg className="w-8 h-8 md:w-10 md:h-10 text-[#22c55e] mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              <h3 className="font-bold text-gray-900 text-sm md:text-base mb-3">QUALITY PRODUCT</h3>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed">
                We meticulously source the finest medicines available in the market, carefully selected to meet the specific needs of our customers. Our unwavering commitment to exceptional customer service is integral to our organizational culture.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 md:p-10 border border-gray-100 shadow-sm">
              <svg className="w-8 h-8 md:w-10 md:h-10 text-[#22c55e] mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" /></svg>
              <h3 className="font-bold text-gray-900 text-sm md:text-base mb-3">SUPPORT 24/7/365</h3>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed">
                Our task remains unfinished until the shipment has successfully arrived at its destination. Our support team consistently offers timely updates and all pertinent technical details to ensure transparency throughout the process.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 md:p-10 border border-gray-100 shadow-sm">
              <svg className="w-8 h-8 md:w-10 md:h-10 text-[#22c55e] mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
              <h3 className="font-bold text-gray-900 text-sm md:text-base mb-3">SECURE & RELIABLE</h3>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed">
                We uphold the highest ethical standards in every facet of our business, striving to cultivate long-term partnerships based on trust, transparency, and mutual respect.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Comprehensive Product Portfolio */}
      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-6">Comprehensive Product Portfolio</h2>
              <p className="text-sm md:text-base text-gray-600 mb-8 leading-relaxed">
                Our extensive product range encompasses various healthcare categories, all sourced from reputable and certified manufacturers. We ensure that every product meets the highest quality standards.
              </p>
              <div className="grid grid-cols-2 gap-y-6 gap-x-8">
                <div className="flex items-center text-sm md:text-base text-gray-700">
                  <svg className="w-5 h-5 text-[#22c55e] mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Prescription Medications
                </div>
                <div className="flex items-center text-sm md:text-base text-gray-700">
                  <svg className="w-5 h-5 text-[#22c55e] mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Generic Drugs
                </div>
                <div className="flex items-center text-sm md:text-base text-gray-700">
                  <svg className="w-5 h-5 text-[#22c55e] mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Surgical Supplies
                </div>
                <div className="flex items-center text-sm md:text-base text-gray-700">
                  <svg className="w-5 h-5 text-[#22c55e] mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Veterinary Supplies
                </div>
                <div className="flex items-center text-sm md:text-base text-gray-700">
                  <svg className="w-5 h-5 text-[#22c55e] mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Over-the-Counter Products
                </div>
                <div className="flex items-center text-sm md:text-base text-gray-700">
                  <svg className="w-5 h-5 text-[#22c55e] mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  Medical Equipment
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#f2fcf5] to-[#f4f7fc] border border-green-100/50 rounded-3xl p-12 text-center flex flex-col items-center justify-center">
              <svg className="w-12 h-12 text-[#22c55e] mb-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
              <h3 className="text-2xl md:text-3xl font-bold text-[#111827] mb-4">Certified Manufacturers</h3>
              <p className="text-sm md:text-base text-[#4b5563] max-w-lg leading-relaxed">
                All our products are sourced from reputable and certified manufacturers, ensuring the highest quality standards for healthcare providers and pharmacies worldwide.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Vision & Mission */}
      <div className="bg-[#f9fafb] py-20 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-3xl p-10 shadow-sm">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#f3e8ff] rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-[#a855f7]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">Our Vision</h3>
              </div>
              <p className="text-sm md:text-base text-gray-600 mb-4 leading-relaxed">
                To be the most trusted and respected global exporter of pharmaceutical products and equipment. We are committed to excellence in customer service, delivering high-quality products, and providing innovative solutions that advance patient care.
              </p>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                By embracing the latest technologies and industry trends, we aim to lead the industry and empower our customers with the tools and resources necessary to thrive in a dynamic healthcare environment.
              </p>
            </div>

            <div className="bg-white rounded-3xl p-10 shadow-sm">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#dcfce7] rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-[#22c55e]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">Our Mission</h3>
              </div>
              <p className="text-sm md:text-base text-gray-600 mb-4 leading-relaxed">
                Our overarching mission is to establish ourselves as the premier provider of pharmaceutical products and comprehensive services tailored to healthcare providers and pharmacies nationwide.
              </p>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Recognizing that the commodification of healthcare shapes medical treatments and determines the therapies accessible to patients, we are dedicated to delivering high-quality, effective pharmaceutical solutions at competitive prices, complemented by exceptional customer service.
              </p>
            </div>
          </div>
        </div>
      </div>


      {/* Wholesale Features Section - Timeline Layout */}
      <div className="py-20 bg-white relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 right-10 w-32 h-32 bg-gradient-to-br from-blue-100/50 to-teal-100/50 rounded-full blur-2xl"></div>
          <div className="absolute bottom-20 left-10 w-40 h-40 bg-gradient-to-br from-green-100/50 to-blue-100/50 rounded-full blur-2xl"></div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Complete <span className="bg-gradient-to-r from-green-500 to-teal-500 bg-clip-text text-transparent">Wholesale Solution</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Advanced tools and features designed specifically for medicine wholesale dealers
            </p>
          </div>

          {/* Timeline Layout */}
          <div className="relative">
            {/* Central Line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-green-400 via-blue-400 to-teal-400 rounded-full"></div>

            {/* Feature Items */}
            <div className="space-y-16">
              {/* Feature 1 - Left */}
              <div className="flex items-center">
                <div className="w-1/2 pr-12 text-right">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-green-500 to-teal-500 rounded-full mb-4 shadow-lg">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Smart Bulk Orders</h3>
                  <p className="text-gray-600 leading-relaxed">
                    AI-powered ordering system with predictive analytics, automated reorder points, and intelligent distributor matching for optimal procurement.
                  </p>
                </div>
                <div className="relative z-10 w-6 h-6 bg-white border-4 border-green-500 rounded-full shadow-lg"></div>
                <div className="w-1/2 pl-12"></div>
              </div>

              {/* Feature 2 - Right */}
              <div className="flex items-center">
                <div className="w-1/2 pr-12"></div>
                <div className="relative z-10 w-6 h-6 bg-white border-4 border-blue-500 rounded-full shadow-lg"></div>
                <div className="w-1/2 pl-12">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full mb-4 shadow-lg">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Advanced Credit Management</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Dynamic credit scoring, flexible payment terms, automated collections, and real-time monitoring for better cash flow management.
                  </p>
                </div>
              </div>

              {/* Feature 3 - Left */}
              <div className="flex items-center">
                <div className="w-1/2 pr-12 text-right">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full mb-4 shadow-lg">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Market Intelligence</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Real-time price tracking, competitor analysis, demand forecasting, and profit optimization recommendations for strategic decisions.
                  </p>
                </div>
                <div className="relative z-10 w-6 h-6 bg-white border-4 border-purple-500 rounded-full shadow-lg"></div>
                <div className="w-1/2 pl-12"></div>
              </div>

              {/* Feature 4 - Right */}
              <div className="flex items-center">
                <div className="w-1/2 pr-12"></div>
                <div className="relative z-10 w-6 h-6 bg-white border-4 border-yellow-500 rounded-full shadow-lg"></div>
                <div className="w-1/2 pl-12">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-full mb-4 shadow-lg">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Regulatory Compliance</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Automated GST calculations, drug license verification, batch tracking, and comprehensive audit trails for complete compliance.
                  </p>
                </div>
              </div>

              {/* Feature 5 - Left */}
              <div className="flex items-center">
                <div className="w-1/2 pr-12 text-right">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-full mb-4 shadow-lg">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Multi-Location Hub</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Centralized management for multiple store locations, automated inventory transfers, and unified performance analytics across branches.
                  </p>
                </div>
                <div className="relative z-10 w-6 h-6 bg-white border-4 border-indigo-500 rounded-full shadow-lg"></div>
                <div className="w-1/2 pl-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Product Categories Section */}
      <div className="py-20 bg-gradient-to-br from-gray-50 to-blue-50 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Medicine <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">Categories</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive wholesale supply across all pharmaceutical categories with competitive pricing
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-red-100 to-pink-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Cardiac & Diabetic</h3>
              <p className="text-gray-600 mb-4">Heart medications, diabetes management, blood pressure control medicines</p>
              <div className="text-sm text-blue-600 font-semibold">5000+ Products</div>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-teal-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Antibiotics & Anti-infectives</h3>
              <p className="text-gray-600 mb-4">Broad spectrum antibiotics, antiviral, antifungal medications</p>
              <div className="text-sm text-blue-600 font-semibold">3500+ Products</div>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Oncology & Specialty</h3>
              <p className="text-gray-600 mb-4">Cancer treatment, rare disease medications, specialty drugs</p>
              <div className="text-sm text-blue-600 font-semibold">1200+ Products</div>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-pink-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Pediatric & Maternal</h3>
              <p className="text-gray-600 mb-4">Children's medicines, pregnancy care, infant nutrition</p>
              <div className="text-sm text-blue-600 font-semibold">2800+ Products</div>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-100 to-orange-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Pain Management</h3>
              <p className="text-gray-600 mb-4">Analgesics, anti-inflammatory, muscle relaxants</p>
              <div className="text-sm text-blue-600 font-semibold">1800+ Products</div>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-indigo-100 to-blue-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Vitamins & Supplements</h3>
              <p className="text-gray-600 mb-4">Nutritional supplements, vitamins, health boosters</p>
              <div className="text-sm text-blue-600 font-semibold">4200+ Products</div>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Testimonials Section */}
      {/* <div className="py-20 bg-white relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              What Our <span className="bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">Customers Say</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Trusted by thousands of pharmacies and medical stores across India
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-2xl p-8 border border-blue-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg mr-4">
                  RS
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Rajesh Sharma</h4>
                  <p className="text-sm text-gray-600">Sharma Medical Store, Delhi</p>
                </div>
              </div>
              <p className="text-gray-700 mb-4">Global Phoenix has been our trusted medicine supplier for 3 years. Their competitive pricing and reliable supply has helped us grow our pharmacy business significantly."</p>
              <div className="flex text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 border border-green-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-lg mr-4">
                  PK
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Priya Kumari</h4>
                  <p className="text-sm text-gray-600">Apollo Distributors, Mumbai</p>
                </div>
              </div>
              <p className="text-gray-700 mb-4">Their flexible credit terms and timely deliveries have improved our cash flow tremendously. Customer support is exceptional - always available when needed."</p>
              <div className="flex text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 border border-purple-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg mr-4">
                  AM
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Amit Mehta</h4>
                  <p className="text-sm text-gray-600">Mehta Pharma, Bangalore</p>
                </div>
              </div>
              <p className="text-gray-700 mb-4">Their wide product range and competitive rates help us serve our customers better. We've increased our profit margins by 12% since partnering with them."</p>
              <div className="flex text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Partnership Benefits Section */}
      {/* <div className="py-20 bg-gradient-to-br from-indigo-50 to-purple-50 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Partnership <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">Benefits</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Exclusive advantages for verified wholesale partners and distributors
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Extended Credit Terms</h3>
                  <p className="text-gray-600">Up to 90 days credit period for verified partners with flexible payment schedules and automated reminders.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Volume-Based Discounts</h3>
                  <p className="text-gray-600">Tiered pricing structure with additional discounts for bulk orders exceeding ₹5 lakhs monthly.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Priority Support</h3>
                  <p className="text-gray-600">Dedicated relationship manager, priority order processing, and 24/7 technical support.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Business Analytics</h3>
                  <p className="text-gray-600">Advanced reporting, sales trends, profit analysis, and market insights to optimize your business.</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 border border-gray-200 shadow-lg">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Become a Partner</h3>
                <p className="text-gray-600">Join our exclusive network of verified wholesale partners</p>
              </div>

              <div className="space-y-6">
                <div className="flex items-center justify-between p-4 bg-gradient-to-r from-green-50 to-teal-50 rounded-xl border border-green-100">
                  <span className="font-semibold text-gray-900">Minimum Order Value</span>
                  <span className="text-green-600 font-bold">₹1 Lakh/Month</span>
                </div>

                <div className="flex items-center justify-between p-4 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl border border-blue-100">
                  <span className="font-semibold text-gray-900">Credit Limit</span>
                  <span className="text-blue-600 font-bold">Up to ₹25 Lakhs</span>
                </div>

                <div className="flex items-center justify-between p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl border border-purple-100">
                  <span className="font-semibold text-gray-900">Additional Margin</span>
                  <span className="text-purple-600 font-bold">5-12% Extra</span>
                </div>

                <div className="flex items-center justify-between p-4 bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl border border-yellow-100">
                  <span className="font-semibold text-gray-900">Free Delivery</span>
                  <span className="text-yellow-600 font-bold">Orders Above ₹50K</span>
                </div>

                <button className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] transform">
                  <span className="flex items-center justify-center space-x-2">
                    <span>Apply for Partnership</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* FAQ Section */}
      {/* <div className="py-20 bg-white relative">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Frequently Asked <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">Questions</span>
            </h2>
            <p className="text-xl text-gray-600">
              Common queries about our wholesale medicine business
            </p>
          </div>

          <div className="space-y-4">
            {[
              {
                question: "What are your minimum order requirements for wholesale purchases?",
                answer: "We maintain a minimum order value of ₹50,000 for standard wholesale accounts and ₹2 lakhs for premium partnership benefits. This structure enables us to offer competitive pricing while ensuring efficient logistics and supply chain management for our valued customers.",
                color: "bg-blue-50 border-blue-200"
              },
              {
                question: "How do your credit facilities and payment terms operate?",
                answer: "Global Phoenix offers flexible credit facilities ranging from 30 to 90 days, subject to credit assessment and business verification. Credit limits are established based on your business profile, financial standing, and order history. Our finance team conducts thorough due diligence to ensure mutually beneficial credit arrangements.",
                color: "bg-green-50 border-green-200"
              },
              {
                question: "What documentation is required for establishing a wholesale account?",
                answer: "To establish a wholesale account with Global Phoenix, you will need: Valid Drug License, GST Registration Certificate, PAN Card, Bank Account Details, Business Registration Certificate, and Address Proof. Our dedicated onboarding team provides comprehensive guidance throughout the documentation and verification process.",
                color: "bg-purple-50 border-purple-200"
              },
              {
                question: "What are your delivery timelines and logistics capabilities?",
                answer: "Our standard delivery timeline is 2-5 business days across India, depending on location and order size. For urgent requirements, we provide expedited delivery services including same-day and next-day delivery in major metropolitan areas. All shipments are tracked and insured for complete peace of mind.",
                color: "bg-yellow-50 border-yellow-200"
              },
              {
                question: "Do you provide business development and marketing support?",
                answer: "Yes, Global Phoenix offers comprehensive business development support including promotional materials, product training programs, digital marketing assistance, and seasonal campaign support. Our dedicated relationship managers work closely with partners to identify growth opportunities and optimize business performance.",
                color: "bg-indigo-50 border-indigo-200"
              },
              {
                question: "What is your quality assurance and return policy?",
                answer: "We maintain strict quality standards and accept returns for damaged, defective, or incorrectly shipped products within 7 days of delivery. All manufacturing defects and shipping errors are resolved immediately at no additional cost. Our quality assurance team ensures all products meet pharmaceutical standards before dispatch.",
                color: "bg-teal-50 border-teal-200"
              }
            ].map((faq, index) => (
              <div key={index} className={`${faq.color} rounded-2xl border transition-all duration-300`}>
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full p-6 text-left flex items-center justify-between hover:bg-opacity-80 transition-all duration-200"
                >
                  <h3 className="text-xl font-bold text-gray-900 pr-4">{faq.question}</h3>
                  <svg
                    className={`w-6 h-6 text-gray-600 transition-transform duration-300 flex-shrink-0 ${openFAQ === index ? 'rotate-180' : ''
                      }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${openFAQ === index ? 'max-h-96 pb-6' : 'max-h-0'
                  }`}>
                  <div className="px-6">
                    <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Partnership Benefits Section - Additional */}
      {/* <div className="py-20 bg-gradient-to-br from-green-50 to-blue-50 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Partnership <span className="bg-gradient-to-r from-green-600 to-teal-600 bg-clip-text text-transparent">Benefits</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Join Global Phoenix as a wholesale partner and unlock exclusive benefits for your pharmacy business
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-teal-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Minimum Order Value</h3>
              <p className="text-gray-600 mb-4">Start your partnership with competitive minimum order requirements</p>
              <div className="text-2xl font-bold text-green-600">Flexible Terms</div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Credit Limit</h3>
              <p className="text-gray-600 mb-4">Flexible credit facility to manage your cash flow effectively</p>
              <div className="text-2xl font-bold text-blue-600">₹25 Lakhs</div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-pink-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Additional Margin</h3>
              <p className="text-gray-600 mb-4">Earn competitive margins on all pharmaceutical products</p>
              <div className="text-2xl font-bold text-purple-600">5-12%</div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-100 to-orange-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Free Delivery</h3>
              <p className="text-gray-600 mb-4">Complimentary delivery service for bulk orders</p>
              <div className="text-2xl font-bold text-yellow-600">Above ₹50K</div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-red-100 to-pink-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Quick Processing</h3>
              <p className="text-gray-600 mb-4">Fast order processing and dispatch within 24 hours</p>
              <div className="text-2xl font-bold text-red-600">24 Hours</div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-indigo-100 to-blue-100 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">24/7 Support</h3>
              <p className="text-gray-600 mb-4">Round-the-clock customer support for all your queries</p>
              <div className="text-2xl font-bold text-indigo-600">Always Available</div>
            </div>
          </div>
        </div>
      </div> */}



      {/* Contact Section */}
      <div className="py-20 bg-white relative">
        <div className="absolute top-0 left-0 w-full">
          <div className="flex justify-center space-x-2 pt-4">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
            <div className="w-2 h-2 bg-cyan-500 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-2 h-2 bg-teal-500 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Get in <span className="bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">Touch</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ready to transform your wholesale medicine business? Contact our team for personalized solutions.
            </p>
          </div>

          <div className="space-y-12">
            {/* Top Section - Map */}
            <div className="bg-white border border-gray-200 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Our Location</h3>
              <div className="relative h-[400px] rounded-xl overflow-hidden">
                <iframe
                  src="https://maps.google.com/maps?q=Sultan%20Bathery,%20Kerala%20673592,%20India&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Global Phoenix Location - Sultan Bathery, Kerala"
                ></iframe>
              </div>
            </div>

            {/* Bottom Section - Contact Form */}
            <div className="bg-white border border-gray-200 rounded-2xl p-8">
              <div className="mb-8 text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Send us a Message</h3>
                <p className="text-gray-600 max-w-2xl mx-auto">Ready to partner with us? Fill out the form below and our team will get back to you within 24 hours.</p>
              </div>

              <div className="max-w-5xl mx-auto">
                <form className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">First Name *</label>
                      <input
                        type="text"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 hover:border-gray-400"
                        placeholder="Enter your first name"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Last Name *</label>
                      <input
                        type="text"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 hover:border-gray-400"
                        placeholder="Enter your last name"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Business Name *</label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 hover:border-gray-400"
                      placeholder="Your pharmacy/wholesale business name"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
                      <input
                        type="tel"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 hover:border-gray-400"
                        placeholder="+91 98765 43210"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
                      <input
                        type="email"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 hover:border-gray-400"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Business Type *</label>
                    <select
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 hover:border-gray-400"
                    >
                      <option value="">Select your business type</option>
                      <option value="pharmacy">Pharmacy/Chemist</option>
                      <option value="distributor">Distributor</option>
                      <option value="wholesaler">Wholesaler</option>
                      <option value="stockist">Stockist</option>
                      <option value="hospital">Hospital/Clinic</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Message</label>
                    <textarea
                      rows={6}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 hover:border-gray-400 resize-none"
                      placeholder="Tell us about your wholesale requirements, expected volume, or any specific questions you may have..."
                    ></textarea>
                  </div>

                  <div className="pt-4">
                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white font-semibold py-4 px-6 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] transform"
                    >
                      <span className="flex items-center justify-center space-x-2">
                        <span>Send Message</span>

                      </span>
                    </button>
                  </div>

                  <p className="text-xs text-gray-500 text-center pt-2">
                    By submitting this form, you agree to our <a href="#" className="text-blue-600 hover:underline font-medium">Terms of Service</a> and <a href="#" className="text-blue-600 hover:underline font-medium">Privacy Policy</a>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
